import { render } from "./ApproveEstimate.vue?vue&type=template&id=ed4495fa"
import script from "./ApproveEstimate.vue?vue&type=script&lang=js"
export * from "./ApproveEstimate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__